import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './users.action';

@Injectable({ providedIn: 'root' })
export class UsersTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                first_name: '', 
                email: '', 
                role: null, //Null for select list
                created_at: '', 
                last_logged_in: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'first_name';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    roles = [];
    hasFilter = false;
    columns = [
                { prop: 'first_name', name: 'USER.full-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'email', name: 'USER.email', sortable: true, hasFilter: true, filter: "input", widthSet: 300},
                { prop: 'roles', name: 'USER.role', sortable: false, hasFilter: true, filter: "select", options: 'roles', options_id: "id", options_label: "role_name" },
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'last_logged_in', name: 'USER.user-logged-in', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            first_name: '', 
            email: '', 
            role: null, 
            created_at: '',
            last_logged_in: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}